import { useCallback } from 'react';

import { useSearchQuery, useSearchSelector } from '../../store';

export const useSearchResults = (size: number) => {
    const { query } = useSearchSelector();
    const { data, isFetching, isError, refetch } = useSearchQuery({ query, size }, { skip: !query.trim() });

    const hasMore = !isError && (data === undefined || Boolean(data?.length));

    const loadMore = useCallback(() => {
        if (hasMore && !isFetching) {
            refetch();
        }
    }, [hasMore, isFetching, refetch]);

    return { data: data ?? [], isLoading: isFetching, loadMore, hasMore };
};
